import { createWebhook } from './createWebhook';
import { deleteWebhook } from './deleteWebhook';
import { fetchWebhooksTriggerTypes } from './fetchTriggerTypes';
import { fetchWebhook } from './fetchWebhook';
import { fetchWebhooks } from './fetchWebhooks';
import { updateWebhook } from './updateWebhook';

export default {
  fetchWebhooks,
  deleteWebhook,
  createWebhook,
  updateWebhook,
  fetchWebhooksTriggerTypes,
  fetchWebhook,
};
